import BaseViewController from "./base-view-controller";

class ConsultationContactInfo extends BaseViewController {
  isFieldActive(fieldName) {
    return !!this.screen.fields.find(f => f.name === fieldName);
  }

  getTextForFieldWithValue(fieldName, value) {
    const field = this.screen.fields.find(f => f.name === fieldName);
    if (field && field.options) {
      const selectedOption = field.options.find(o => o.value === value);
      if (selectedOption && selectedOption.text) {
        return selectedOption.text;
      }
    }
  }

  getEmailText(fieldName, otherFieldName, values) {
    return this.isFieldActive(otherFieldName)
      ? values[otherFieldName]
      : this.getTextForFieldWithValue(fieldName, values[fieldName]);
  }

  preprocessScreenData() {
    if (this.appData.lastNavAction !== "next") {
      // country_state prop in the body doesn't allow us to move back to the previous screen
      this.appData.values.country_state = "";
    }
    const emailField = this.screen.fields.find(
      f => f.name === "email_notification"
    );
    if (emailField && emailField.options.length && this.appData.isPulse) {
      emailField.options.forEach(option => {
        if (option?.value === "0" && option?.text.length > 2) {
          option.text = `${option.text[0].toUpperCase()}${option.text.slice(
            1
          )}`;
        }
      });
    }
  }

  prepareSubmit(values) {
    const emailNotificationFieldName = "email_notification";
    const emailNotificationOtherFieldName = "email_notification_other";
    const addlEmailNotificationFieldName =
      "additional_participants.0.email_notification";
    const addlEmailNotificationOtherFieldName =
      "additional_participants.0.email_notification_other";
    const modifiedValues = { ...values };

    if (
      !modifiedValues[emailNotificationFieldName] &&
      !modifiedValues[addlEmailNotificationFieldName]
    ) {
      modifiedValues[emailNotificationFieldName] = "0";
    } else if (
      !modifiedValues.email_notification &&
      modifiedValues[addlEmailNotificationFieldName]
    ) {
      modifiedValues[emailNotificationFieldName] = "0";
      modifiedValues.email = this.getEmailText(
        addlEmailNotificationFieldName,
        addlEmailNotificationOtherFieldName,
        modifiedValues
      );
    } else if (
      modifiedValues[emailNotificationFieldName] &&
      !modifiedValues[addlEmailNotificationFieldName]
    ) {
      modifiedValues.email = this.getEmailText(
        emailNotificationFieldName,
        emailNotificationOtherFieldName,
        modifiedValues
      );
    } else {
      modifiedValues.email = `${this.getEmailText(
        emailNotificationFieldName,
        emailNotificationOtherFieldName,
        modifiedValues
      )} & ${this.getEmailText(
        addlEmailNotificationFieldName,
        addlEmailNotificationOtherFieldName,
        modifiedValues
      )}`;
    }
    const phonePickerFields = this.screen.fields
      .map(field =>
        field.params?.split("|").includes("TDFieldOptionCountryPhoneNumber")
          ? field.name
          : null
      )
      .filter(field => field);
    Object.keys(modifiedValues).forEach(fieldKey => {
      if (
        phonePickerFields.includes(fieldKey) &&
        modifiedValues[fieldKey]?.phoneNumber
      ) {
        modifiedValues[fieldKey].phoneNumber = modifiedValues[
          fieldKey
        ].phoneNumber.includes("+")
          ? modifiedValues[fieldKey].phoneNumber.slice(
              `${modifiedValues[fieldKey].countryCode}`.length + 1
            )
          : modifiedValues[fieldKey].phoneNumber;
        modifiedValues[fieldKey] = JSON.stringify(modifiedValues[fieldKey]);
      }
    });

    return modifiedValues;
  }
}

export default ConsultationContactInfo;
